// Colour contrast (WCAG relative luminance). Kept free of other imports so the theme
// code (theme/agency-theme.js) can use it, and be tested, on its own.
function getLuminance(color) {
  const value = String(color || '').replace('#', '')
  const hex = value.length === 3 ? value.split('').map((part) => part + part).join('') : value
  const channels = [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16) / 255)
  const linear = channels.map((channel) =>
    channel <= 0.03928
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4)
  )

  return 0.2126 * linear[0] + 0.7152 * linear[1] + 0.0722 * linear[2]
}
function getContrastRatio(color1, color2) {
  const luminance1 = getLuminance(color1)
  const luminance2 = getLuminance(color2)

  const brighter = Math.max(luminance1, luminance2)
  const darker = Math.min(luminance1, luminance2)

  return (brighter + 0.05) / (darker + 0.05)
}
function invertTextColor(background) {
  const textColor =
    getContrastRatio(background, '#000000') >
    getContrastRatio(background, '#FFFFFF')
      ? '#000000'
      : '#FFFFFF'
  return textColor
}

function getReadableTextColor(background, preferred, minimum = 4.5) {
  const candidate = preferred || '#000000'
  return getContrastRatio(background, candidate) >= minimum
    ? candidate
    : invertTextColor(background)
}

export { getLuminance, getContrastRatio, invertTextColor, getReadableTextColor }
